import React from "react";

export const generalContent = {
  introduction: {
    title: "Introduction",
    content: (
      <>
        <p>
          Welcome to the TrendPad Documentation. TrendPad is a decentralized
          launchpad protocol that allows projects to launch their tokens and
          raise funds in a secure and decentralized manner.
        </p>
        <p>
          Our platform supports multiple blockchains including Ethereum, BSC,
          Polygon, Avalanche, Arbitrum, Optimism, Base, Celo, and Fantom. We
          provide a suite of tools for project owners and investors, ensuring a
          seamless experience for token sales, locking, airdrops, and more.
        </p>
      </>
    ),
  },
  token_metrics: {
    title: "Token Metrics",
    content: (
      <>
        <p>
          Understanding token metrics is crucial for evaluating a project's
          potential. TrendPad provides transparent display of token metrics for
          every launchpad.
        </p>
        <ul>
          <li>
            <strong>Total Supply:</strong> The total amount of tokens created.
          </li>
          <li>
            <strong>Presale Rate:</strong> Number of tokens per 1 ETH/BNB/etc.
            during presale.
          </li>
          <li>
            <strong>Listing Rate:</strong> Number of tokens per 1 ETH/BNB/etc.
            upon listing on DEX.
          </li>
          <li>
            <strong>Initial Market Cap:</strong> Estimated market cap at launch.
          </li>
          <li>
            <strong>Soft Cap:</strong> Minimum funds required for the presale to
            be successful.
          </li>
          <li>
            <strong>Hard Cap:</strong> Maximum funds that can be raised.
          </li>
        </ul>
      </>
    ),
  },
  service_fees: {
    title: "Service Fees",
    content: (
      <>
        <h3>TrendPad Service Fees</h3>
        <p>
          We strive to keep our fees competitive and transparent. Below is a
          comprehensive breakdown of fees across all supported networks.
        </p>

        <h4>Fee Schedule</h4>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr style={{ borderBottom: "2px solid #ddd" }}>
                <th style={{ textAlign: "left", padding: "10px" }}>Network</th>
                <th style={{ textAlign: "left", padding: "10px" }}>
                  Launchpad / Presale
                </th>
                <th style={{ textAlign: "left", padding: "10px" }}>
                  MultiSend / Airdrop
                </th>
                <th style={{ textAlign: "left", padding: "10px" }}>
                  TrendLock
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  BSC Mainnet
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.5 BNB + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 BNB
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  BSC Testnet
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.001 tBNB + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 tBNB
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Polygon (POL)
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  50 POL + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 POL
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Celo
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  300 CELO + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 CELO
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Ethereum
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.1 ETH + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 ETH
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Avalanche
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  5 AVAX + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 AVAX
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Arbitrum
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.1 ETH + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 ETH
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Optimism
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.1 ETH + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 ETH
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Base
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.1 ETH + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 ETH
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Fantom
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  300 FTM + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.01 FTM
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
              <tr>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Sepolia
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  0.0001 ETH + 3%
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                  Free
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h4>Q&A</h4>
        <ul>
          <li>
            <strong>Q: How do I pay fees?</strong>
            <br />
            A: <strong>Upfront Fees</strong> are paid from your wallet when
            creating a sale. <strong>Percentage Fees</strong> are automatically
            deducted from the raised funds upon finalization.
          </li>
          <li>
            <strong>Q: What if my sale fails?</strong>
            <br />
            A: If a sale fails (Soft Cap not met), the percentage fee is NOT
            charged. However, the upfront creation fee is non-refundable as the
            service was used.
          </li>
          <li>
            <strong>Q: Are fees the same on all chains?</strong>
            <br />
            A: No, please refer to the table above for network-specific fees.
          </li>
        </ul>
      </>
    ),
  },
};
